module.exports = __webpack_public_path__ + "static/media/tinywow_3024Plataneeinzeln_colored_55475923.5d7a59b9.jpg";